/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { of as observableOf, Observable } from 'rxjs';
import { FacilitiesApi } from '../api/facilities.api';
import { FacilityData, Facility } from '../../../interfaces/solar/facilities';

@Injectable()
export class FacilitiesService extends FacilityData {

  private data: Facility[] = [
    {
      id: 1,
      name: 'Zaichevskoe',
    },
    {
      id: 2,
      name: 'Pukhovka',
    },
  ];

  constructor(private api: FacilitiesApi) {
    super();
  }

  list(): Observable<Facility[]> {
    // return this.api.list();
    return observableOf(this.data);
  }
}
